export default __webpack_public_path__ + "static/media/480_private01-nl-web.ac247713.png";